// Author TianHaiQing
// Date 2022-06-14 20:26:00

class PartyBuildingTest {
constructor({
        id = null,
        test1 = '',
        test2 = '',
        remark = ''}
= {}) {
    this.id = id;
    this.test1 = test1;
    this.test2 = test2;
    this.remark = remark;
}
}

function newEntity() {
return new PartyBuildingTest();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.partyBuilding.partyBuildingTest.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'test1',
        label: 'label.partyBuilding.partyBuildingTest.grid.test1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'test2',
        label: 'label.partyBuilding.partyBuildingTest.grid.test2',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.partyBuilding.partyBuildingTest.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    test1Filter : '',
    test2Filter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'test1Filter',
        label: 'label.partyBuilding.partyBuildingTest.filter.test1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'test2Filter',
        label: 'label.partyBuilding.partyBuildingTest.filter.test2',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'test1',
        label: 'label.partyBuilding.partyBuildingTest.entity.test1',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'test2',
        label: 'label.partyBuilding.partyBuildingTest.entity.test2',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.partyBuilding.partyBuildingTest.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {PartyBuildingTest, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
